import { AcessLevel } from "@/types/permission.types";

export interface IProfile {
  id: number;
  code: ProfileCode;
  label: string;
  rowdate: Date;
  profileModule: IProfileModule[];
}

export interface IProfileModule {
  profileId: number;
  moduleId: number;
  accessLevel: AcessLevel;
  rowDate: Date;
}

export interface IUserProfile {
  userId: number;
  profileId: number;
  rowDate: Date;
}

export interface IPermission {
  id: number;
  code: string;
  label: string;
  endpoint: string;
  restricted: number;
  rowdate: Date;
}

export enum ProfileCode {
  ADMINISTRATOR = "ADMINISTRATOR",
  MANAGER = "MANAGER",
  ATTENDANT = "ATTENDANT",
  REPRESENTATIVE = "REPRESENTATIVE",
  OPERATIONS = "OPERATIONS",
}

export interface IInsertUserProfile extends Omit<IUserProfile, "rowDate"> {}
